class NewsletterSignup {
  constructor() {
    this.KLAVIYO_PUBLIC_KEY = 'VJzX4x';
    this.CLIENT_API_BASE = 'https://a.klaviyo.com/client';
    this.NEWSLETTER_LIST_ID = 'TqW7qA';
    this.RETRY_QUEUE_KEY = 'nl_retry_queue';
    this.MAX_RETRIES = 3;
    this.emailInput = null;
    this.nameInput = null;
    this.consentCheckbox = null;
    this.submitBtn = null;
    this.validDomains = [
      'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com',
      'icloud.com', 'mail.com', 'gmx.com', 'web.de', 'live.com',
      'msn.com', 'googlemail.com', 'yandex.com', 'mail.ru', 'inbox.com',
      'protonmail.com', 'tutanota.com', 'fastmail.com', 'zoho.com'
    ];
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
  this.emailInput = document.getElementById('SelvaroNewsletterEmail');
  this.nameInput = document.getElementById('SelvaroNewsletterName');
  this.consentCheckbox = document.getElementById('SelvaroNewsletterConsent');
  this.submitBtn = document.getElementById('SelvaroNewsletterSubmit');
  if (!this.emailInput || !this.submitBtn) return;
  this.bindEvents();
  this.setupFormValidation();
  this.flushQueue();
}

  bindEvents() {
    this.submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
    window.addEventListener('online', () => this.flushQueue());
  }

 setupFormValidation() {
  const validateForm = () => {
    const email = this.emailInput.value.trim();
    const consentChecked = this.consentCheckbox ? this.consentCheckbox.checked : true; // ✅ якщо чекбокса нема → true
    this.submitBtn.disabled = !(email.length > 0 && consentChecked);
  };
  
  this.emailInput.addEventListener('input', validateForm);
  if (this.consentCheckbox) {
    this.consentCheckbox.addEventListener('change', validateForm);
  }
  validateForm();
}

  isValidEmail(email) {
    const basicPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!basicPattern.test(email)) return false;
    
    const parts = email.split('@');
    if (parts.length !== 2) return false;
    
    const [localPart, domain] = parts;
    if (localPart.length === 0 || domain.length === 0) return false;
    
    const domainParts = domain.split('.');
    if (domainParts.length < 2) return false;
    
    const tld = domainParts[domainParts.length - 1];
    if (tld.length < 2 || tld.length > 6) return false;
    
    if (domain.includes('..') || domain.startsWith('.') || domain.endsWith('.')) return false;
    
    const validTlds = [
      'com', 'org', 'net', 'edu', 'gov', 'mil', 'int', 'co', 'uk', 'de', 
      'fr', 'it', 'es', 'ru', 'jp', 'cn', 'au', 'ca', 'br', 'mx', 'pl',
      'nl', 'be', 'ch', 'at', 'se', 'dk', 'no', 'fi', 'cz', 'hu', 'pt',
      'ie', 'gr', 'bg', 'ro', 'sk', 'si', 'hr', 'ee', 'lv', 'lt', 'lu',
      'mt', 'cy', 'ua', 'by', 'md', 'info', 'biz', 'name', 'pro', 'travel',
      'jobs', 'mobi', 'tel', 'asia', 'cat', 'coop', 'museum', 'aero'
    ];
    
    if (!validTlds.includes(tld.toLowerCase())) return false;
    
    const invalidDomains = [
      'gmail.oom', 'gmail.co', 'gmail.ocm', 'gmail.cm', 'gmai.com', 'gmial.com',
      'gnail.com', 'gamil.com', 'gmaill.com', 'gmali.com', 'gmai.co',
      'yahoo.oom', 'yahoo.co', 'yahho.com', 'yaho.com', 'yahooo.com',
      'hotmail.oom', 'hotmail.co', 'hotmai.com', 'hotmial.com', 'hotmil.com',
      'outlook.oom', 'outlook.co', 'outlok.com', 'outloo.com', 'outlok.co'
    ];
    
    if (invalidDomains.includes(domain.toLowerCase())) return false;
    
    return true;
  }

  getEmailErrorMessage(email) {
    if (!email.includes('@')) {
      return 'E-Mail muss ein @ enthalten';
    }
    
    const domain = email.split('@')[1];
    if (!domain) {
      return 'Ungültige E-Mail-Adresse';
    }
    
    const domainLower = domain.toLowerCase();
    const suggestions = {
      'gmail.oom': 'gmail.com',
      'gmail.co': 'gmail.com',
      'gmail.ocm': 'gmail.com',
      'gmail.cm': 'gmail.com',
      'gmai.com': 'gmail.com',
      'gmial.com': 'gmail.com',
      'gnail.com': 'gmail.com',
      'gamil.com': 'gmail.com',
      'gmaill.com': 'gmail.com',
      'gmali.com': 'gmail.com',
      'gmai.co': 'gmail.com',
      'yahoo.oom': 'yahoo.com',
      'yahoo.co': 'yahoo.com',
      'yahho.com': 'yahoo.com',
      'yaho.com': 'yahoo.com',
      'yahooo.com': 'yahoo.com',
      'hotmail.oom': 'hotmail.com',
      'hotmail.co': 'hotmail.com',
      'hotmai.com': 'hotmail.com',
      'hotmial.com': 'hotmail.com',
      'hotmil.com': 'hotmail.com',
      'outlook.oom': 'outlook.com',
      'outlook.co': 'outlook.com',
      'outlok.com': 'outlook.com',
      'outloo.com': 'outlook.com',
      'outlok.co': 'outlook.com'
    };
    
    if (suggestions[domainLower]) {
      return `Meinten Sie ${suggestions[domainLower]}?`;
    }
    
    if (!domain.includes('.')) {
      return 'E-Mail-Adresse benötigt gültige Domain';
    }
    
    const tld = domain.split('.').pop();
    if (tld && (tld.length < 2 || tld.length > 6)) {
      return 'Ungültige Domain-Endung';
    }
    
    return 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
  }

  async handleSubmit() {
    const honeypot = document.querySelector('.selvaro-newsletter__honeypot');
    if (honeypot && honeypot.value) return;
    
    const email = this.emailInput.value.trim();
    const firstName = this.nameInput.value.trim() || '';
    const consentGiven = this.consentCheckbox ? this.consentCheckbox.checked : true;
    
    if (!this.isValidEmail(email)) {
      this.showError('SelvaroNewsletterEmailError', this.getEmailErrorMessage(email));
      this.emailInput.classList.add('invalid');
      return;
    }
    
    if (!consentGiven) {
      this.showError('SelvaroNewsletterConsentError', 'Bitte stimmen Sie dem Erhalt des Newsletters zu');
      return;
    }

    this.setLoadingState(true);
    this.clearAllErrors();

    try {
      await this.subscribeToNewsletter(email, firstName, consentGiven);
      this.showSuccess();
    } catch (error) {
      try {
        await this.subscribeViaKlaviyoJS(email, firstName);
        this.showSuccess();
      } catch (jsError) {
        this.enqueueEvent(email, firstName, consentGiven);
        this.showError('SelvaroNewsletterEmailError', 'Verbindungsfehler. Ihre Anfrage wurde gespeichert.');
      }
    } finally {
      this.setLoadingState(false);
    }
  }

  getSource() {
    const path = window.location.pathname.toLowerCase();
    if (path === '/' || path === '' || path === '/index') {
      return 'homepage';
    }
    if (path.includes('/blog') || path.includes('/blogs')) {
      return 'blog';
    }
    if (path.includes('/about')) return 'about';
    if (path.includes('/contact')) return 'contact';
    if (path.includes('/product')) return 'product';
    if (path.includes('/collection')) return 'collection';
    const pathSegments = path.split('/').filter(segment => segment);
    return pathSegments.length > 0 ? pathSegments[0] : 'unknown';
  }

  async klaviyoClientPost(path, payload) {
    const url = `https://a.klaviyo.com${path}?company_id=${this.KLAVIYO_PUBLIC_KEY}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2025-07-15'
      },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors'
    });
    
    if (!res.ok && res.status !== 202) {
      const text = await res.text().catch(() => '');
      throw new Error(`Klaviyo client POST failed: ${res.status} ${text}`);
    }
    
    return true;
  }

  async subscribeToNewsletter(email, firstName, consentGiven) {
    const source = this.getSource();
    const profileProperties = {
      newsletter_signup: true,
      signup_source: source,
      last_signup_date: new Date().toISOString(),
      consent_given: consentGiven,
      signup_method: 'newsletter_form',
      page_url: window.location.href,
      page_title: document.title
    };

    const subscriptionPayload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter Form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                first_name: firstName || '',
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED' 
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: this.NEWSLETTER_LIST_ID } }
        }
      }
    };

    try {
      await this.klaviyoClientPost('/client/subscriptions', subscriptionPayload);
    } catch (subscriptionError) {
      throw subscriptionError;
    }

    try {
      const eventPayload = {
        data: {
          type: 'event',
          attributes: {
            metric: { 
              data: { 
                type: 'metric', 
                attributes: { 
                  name: 'Newsletter Signup' 
                } 
              } 
            },
            properties: { 
              ...profileProperties, 
              list_id: this.NEWSLETTER_LIST_ID 
            },
            profile: { 
              data: { 
                type: 'profile', 
                attributes: { 
                  email, 
                  first_name: firstName || '' 
                } 
              } 
            }
          }
        }
      };

      await this.klaviyoClientPost('/client/events', eventPayload);
    } catch (eventError) {
      // Silent fail for events
    }

    if (window.klaviyo) {
      try {
        window.klaviyo.identify({ 
          $email: email, 
          $first_name: firstName, 
          ...profileProperties 
        });
        window.klaviyo.track('Newsletter Signup', { 
          ...profileProperties, 
          $email: email, 
          $first_name: firstName 
        });
      } catch (klaviyoError) {
        // Silent fail for JS tracking
      }
    }

    return { success: true };
  }

  async subscribeViaKlaviyoJS(email, firstName) {
    return new Promise((resolve, reject) => {
      if (!window.klaviyo) {
        reject(new Error('Klaviyo JS not loaded'));
        return;
      }

      try {
        const source = this.getSource();
        const eventProperties = {
          source: source,
          signup_method: 'newsletter_form',
          page_url: window.location.href,
          page_title: document.title
        };

        window.klaviyo.identify({
          email: email,
          first_name: firstName,
          newsletter_signup: true,
          signup_source: source
        });

        window.klaviyo.track('Newsletter Signup', eventProperties);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  enqueueEvent(email, firstName, consentGiven) {
    try {
      const queue = this.getRetryQueue();
      queue.push({
        email,
        firstName,
        consentGiven,
        source: this.getSource(),
        timestamp: Date.now(),
        retries: 0
      });
      localStorage.setItem(this.RETRY_QUEUE_KEY, JSON.stringify(queue));
    } catch (e) {
      // Silent fail for queue
    }
  }

  async flushQueue() {
    const queue = this.getRetryQueue();
    if (!queue.length) return;
    const processed = [];
    for (const event of queue) {
      if (event.retries >= this.MAX_RETRIES) {
        processed.push(event);
        continue;
      }
      try {
        const delay = Math.pow(2, event.retries) * 1000;
        if (Date.now() - event.timestamp < delay) continue;
        await this.subscribeToNewsletter(event.email, event.firstName, event.consentGiven);
        processed.push(event);
      } catch (err) {
        event.retries++;
        event.timestamp = Date.now();
      }
    }
    const remaining = queue.filter(ev => !processed.includes(ev));
    localStorage.setItem(this.RETRY_QUEUE_KEY, JSON.stringify(remaining));
  }

  getRetryQueue() {
    try {
      const raw = localStorage.getItem(this.RETRY_QUEUE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  setLoadingState(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    this.submitBtn.classList.toggle('loading', loading);
    const buttonText = this.submitBtn.querySelector('.selvaro-newsletter__button-text');
    const loadingText = this.submitBtn.querySelector('.selvaro-newsletter__loading');
    if (buttonText && loadingText) {
      if (loading) {
        buttonText.style.display = 'none';
        loadingText.style.display = 'block';
      } else {
        buttonText.style.display = 'block';
        loadingText.style.display = 'none';
      }
    }
  }

  showSuccess() {
    const form = document.querySelector('.selvaro-newsletter__form');
    const successMsg = document.getElementById('SelvaroNewsletterSuccess');
    if (form) form.style.display = 'none';
    if (successMsg) successMsg.style.display = 'block';
  }

  showError(id, message) {
    const el = document.getElementById(id);
    if (el) el.textContent = message;
  }

  clearError(id) {
    const el = document.getElementById(id);
    if (el) el.textContent = '';
  }

  clearAllErrors() {
    document.querySelectorAll('.selvaro-newsletter__error').forEach(el => el.textContent = '');
    this.emailInput.classList.remove('invalid');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new NewsletterSignup();
});

if (document.readyState === 'complete') {
  new NewsletterSignup();
}